// it automatically picks up 2x pictures if found as a prefix to the actual names
export var logoTypes = {
  SQUARE: 'square',
  SPREADMARK: 'spreadmark'
};
export function getLogoImages() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  return {
    square: 'volvo-logo.png',
    square2x: 'volvo-logo-2x.png',
    spreadmark: variant === 'dark' ? 'volvo-wordmark.svg' : 'volvo-wordmark-black.svg'
  };
}